import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-benutzer-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenRolleBenutzerAdminEffects {

    RolleBenutzerAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_BENUTZER_ADMIN),
        mergeMap((x: ac.GetRolleBenutzerAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleBenutzerAdmin(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetRolleBenutzerAdminErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleBenutzerAdminFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
